import { validate as isUuid } from "uuid";

export const RequiredMessage = "This field is required!";
export const GuidMessage = "Insert a valid GUID";

export interface SpaceFields {
    title: string;
    description: string;
    /** The Azure DevOps project GUID; optional. */
    projectId: string;
}

export type SpaceFieldErrors = Partial<Record<keyof SpaceFields, string>>;

/** Title and description are required; the project id is optional and, when given, a GUID (the rules of the old forms). */
export function validateSpaceFields(fields: SpaceFields): SpaceFieldErrors {
    const errors: SpaceFieldErrors = {};
    if (!fields.title.trim()) errors.title = RequiredMessage;
    if (!fields.description.trim()) errors.description = RequiredMessage;
    const projectId = fields.projectId.trim();
    if (projectId && !isUuid(projectId)) errors.projectId = GuidMessage;
    return errors;
}

export function hasErrors(errors: SpaceFieldErrors): boolean {
    return Object.values(errors).some(Boolean);
}

const letterTones = ["accent", "command", "success", "warning", "info"] as const;

/** A stable letter-tile colour per space (the boards vary them; the id keeps a space's colour fixed). */
export function spaceTone(spaceId: number): (typeof letterTones)[number] {
    return letterTones[Math.abs(spaceId) % letterTones.length];
}

/** "1 page" / "142 pages". */
export function pagesLabel(count: number): string {
    return `${count} ${count === 1 ? "page" : "pages"}`;
}

/** "1 change request" / "3 change requests". */
export function changeRequestsLabel(count: number): string {
    return `${count} change ${count === 1 ? "request" : "requests"}`;
}
